import React from "react";
import AnimatedList from "../general/animatedlist.tsx";
import { engineeringCards } from "../specific_projects/engineeringData.tsx";

function Projects() {
    return (
        <>
            <div className="text-center">
                <p className="text-5xl pt-10 font-semibold">Recent Projects</p>
            </div>
            <AnimatedList items={engineeringCards.slice(0, 3)} active={true} reset={1}/>
        </>
    );
}
export default Projects;
